import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { ca } from '@cian/analytics';
import { useLocation } from 'react-router-dom';
import { useDeviceType } from '@cian/ui-kit';

import { TagScrollingContainer } from '../TagScrolling';
import { MainArticleAndMainNewsContainer } from '../MainArticleAndMainNews';
import { CardListContainer } from '../CardList';
import { selectInitialPageNumber } from '../../selectors/settings/selectInitialPageNumber';
import { combineDataLayerObject } from '../../../app/helpers/combine_data_layer_object';
import { selectAnalytics } from '../../selectors/analytics';

export const MainPage = () => {
  const initialPageNumber = useSelector(selectInitialPageNumber);
  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const [withTag, setWithTag] = useState(searchParams.get('with-tag') || '');
  const [currentPage, setCurrentPage] = useState(parseInt(searchParams.get('page') as string, 10) || 1);
  const deviceType = useDeviceType();
  const analytics = useSelector(selectAnalytics);

  useEffect(() => {
    const qsPage = parseInt(searchParams.get('page') as string, 10) || 1;
    const qsWithTag = searchParams.get('with-tag') || '';
    const breadCrumbs = ['Журнал'] as string[];

    /** Если страница не изменилась и тэг не изменился -> ничего не делаем */
    if (qsPage === currentPage && qsWithTag === withTag) {
      return;
    }

    if (qsWithTag) {
      breadCrumbs.push(qsWithTag.charAt(0).toUpperCase() + qsWithTag.slice(1));
    }

    if (qsWithTag !== withTag) {
      // Если тэг меняется, то отправляем событие просмотра страницы
      ca('pageviewSite', combineDataLayerObject(analytics, breadCrumbs, deviceType));
    } else if (qsPage !== currentPage) {
      // Если подгружаем статьи, то отправляем событие newpage_infinite_search
      ca('event', {
        name: 'oldevent',
        category: 'page',
        action: 'newpage_infinite_search',
        label: '',
        ...combineDataLayerObject(analytics, breadCrumbs, deviceType),
      });
    }

    setCurrentPage(qsPage);
    setWithTag(qsWithTag);
  }, [analytics, currentPage, deviceType, searchParams, withTag]);

  return (
    <>
      <TagScrollingContainer />
      {/* Показываем только тогда, когда приложение стартовало с первой страницы */}
      {initialPageNumber === 1 && <MainArticleAndMainNewsContainer />}
      <CardListContainer />
    </>
  );
};
